module.exports = __webpack_public_path__ + "img/xinyudonglu.cbf04a17.jpg";